import * as React from 'react';

import classnames from 'classnames';

import { Text } from '../../../Typography';
import { type StepperStatus, type StepperType } from '../../Stepper';

import styles from './StepIcon.module.scss';

export type StepIconProps = {
    type?: StepperType;
    active?: boolean;
    icon?: React.ReactNode;
    status: StepperStatus;
    stepNumber: number;
};

export const StepIcon = ({ type = 'number', active, icon, status, stepNumber }: StepIconProps) => {
    const renderIconNode = () => {
        if (type === 'number') {
            return (
                <Text
                    type={status === 'finish' || active ? 'label' : 'small'}
                    className={styles.icon}
                >
                    {stepNumber}
                </Text>
            );
        }
        if (type === 'dot') {
            return <span className={styles.icon} />;
        }
        if (icon && typeof icon !== 'string') {
            return <span className={styles.icon}>{icon}</span>;
        }
        if (icon || status === 'finish') {
            return <span className={styles.icon} />;
        }
        return <span className={styles.icon}>{stepNumber}</span>;
    };

    return (
        <div
            className={classnames(styles.container, styles[type], styles[status], {
                [styles.active]: active
            })}
        >
            {renderIconNode()}
        </div>
    );
};
